import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-head" }
const _hoisted_2 = { class: "card-eyebrow" }
const _hoisted_3 = { class: "card-figure" }
const _hoisted_4 = {
  key: 0,
  class: "figure-prefix"
}
const _hoisted_5 = {
  key: 1,
  class: "figure-unit"
}
const _hoisted_6 = {
  key: 0,
  class: "card-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeltaPill = _resolveComponent("DeltaPill")!
  const _component_Odometer = _resolveComponent("Odometer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['metric-card', 'm-surface', { 'is-clickable': _ctx.clickable }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _renderSlot(_ctx.$slots, "extra", {}, () => [
        (_ctx.delta !== undefined)
          ? (_openBlock(), _createBlock(_component_DeltaPill, {
              key: 0,
              value: _ctx.delta,
              suffix: _ctx.deltaSuffix
            }, null, 8, ["value", "suffix"]))
          : _createCommentVNode("", true)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.prefix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.prefix), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_Odometer, {
        value: _ctx.value,
        decimals: _ctx.decimals,
        group: true
      }, null, 8, ["value", "decimals"]),
      (_ctx.unit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.unit), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hint || _ctx.$slots.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "hint", {}, () => [
            _createElementVNode("span", null, _toDisplayString(_ctx.hint), 1)
          ], true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}